<div class="min-vh-100 d-flex flex-column container-fluid">
  <site-header class="row"/>

  <app-toast />
  <router-outlet class="row"/>

  <site-footer class="row"/>
</div>
